import type {GetServerSideProps, GetServerSidePropsResult} from 'next';
import Head from 'next/head';
import {useRouter} from 'next/router';
import {GSSKT_HOST} from '../../config/constants/hosts';
import {RegisterLayout} from '../../features/register/components/RegisterLayout';
import {StudentCardPage} from '../../features/register/components/StudentCardPage';
import {withHandler} from '../../server/token/withHandler';
import {ScriptForGA} from '../../shared/components/ScriptForGA';
import type {NextPageWithLayout} from '../_app';

export type Props = Record<string, unknown>;

export const getServerSideProps: GetServerSideProps = withHandler<
  Props,
  'withOptionalSession'
>({auth: 'optional'}, async (): Promise<GetServerSidePropsResult<Props>> => {
  return {
    props: {},
  };
});

const StudentCard: NextPageWithLayout = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;
  const headTitle = '会員登録 | 外資就活ドットコム';

  return (
    <>
      <Head>
        <title key="title">{headTitle}</title>
        <link rel="canonical" href={currentUrl} key="canonical" />
        <meta key="og:title" property="og:title" content={`${headTitle}`} />
        <meta key="og:url" property="og:url" content={currentUrl} />
      </Head>
      <RegisterLayout>
        <StudentCardPage />
      </RegisterLayout>
      <ScriptForGA />
    </>
  );
};

export default StudentCard;
